import { useMutation } from 'react-query';
import {useAuthStore} from "../../../store/auth.store";
import {PartnerApi} from "../../../api/partner.api";

export const useRefreshToken = () => {
    const setToken = useAuthStore((state) => state.setToken);

    return useMutation(PartnerApi.refreshToken, {
        onSuccess: (data) => {
            // Uložení uživatelských dat do Zustand store
            if ("token" in data) {
                setToken(data.token);
                // Uložení tokenu do LocalStorage
                localStorage.setItem('token', data.token);
            }
        },
        onError: (error) => {
            console.log(error);
            console.error('RefreshToken failed:', error);
        },
    });
};